import React, { useEffect } from 'react';

const PrevArrowSlider = (props) => {
    const { className, onClick } = props;

    return (
        <button type="button" className={className} onClick={onClick}></button>
    )
}

export default PrevArrowSlider;